import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { $ } from 'rype-bootstrap';

import { openModal } from '../../../actions/modalActions';

import './ModalButton.css';

// ModalButton requires the modalId prop to be passed into it
// so that the appropriate modal can be displayed on the page
class ModalButton extends Component {
  static get propTypes() {
    return {
      modalId: PropTypes.string.isRequired,
      modalProps: PropTypes.object,
      openModal: PropTypes.func.isRequired,
      type: PropTypes.oneOf(['button', 'link'])
    };
  }

  static get defaultProps() {
    return { type: 'button' };
  }

  render() {
    // pull off modalId and openModal to remove error message
    // caused by <Button> not understanding those properties
    const {
      modalId, className, openModal, type, modalProps, ...otherProps
    } = this.props; // eslint-disable-line no-unused-vars

    switch (type) {
      case 'button': {
        return (
          <button
            type="button"
            className={`ModalButton btn ${className}`}
            onClick={openModal}
            {...otherProps}
          />
        );
      }
      case 'link': {
        return (
          <Link
            className={className}
            onClick={event => {
              event.preventDefault();
              openModal();
            }}
            {...otherProps}
          />
        );
      }
      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openModal: () => {
      let existingModal = false;
      const $modals = $('.modal');
      $modals.each(function () {
        if (this.id !== 'confirmation-modal') {
          $(this).modal('hide');
          existingModal = true;
        }
      });

      const delay = existingModal ? 500 : 0;
      setTimeout(() => {
        dispatch(openModal(ownProps.modalId, ownProps.modalProps));
      }, delay);
    }
  };
}

export default connect(null, mapDispatchToProps)(ModalButton);



// WEBPACK FOOTER //
// ./src/components/modals/ModalButton/ModalButton.js